import { observer } from 'mobx-react-lite'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { Avatar, Button, Typography } from 'shared/ui'
import { type IResponseUser } from 'entities/Users/api/types'
import { type MembersStore } from 'pages/settings/pages/inboxes/pages/id/store/membersStore'
import styles from './styles.module.scss'

type IChangeOwnerModalContentProps = {
  store: MembersStore
  member: IResponseUser
}

export const ChangeOwnerModalContent = observer(({ store }: IChangeOwnerModalContentProps) => {
  const {
    nonOwnerAndViewOnlyMembers,
    organizationMembersLoading,
    newOwner,
    setNewOwner,
    handleMakeOwner,
    handleCancel,
  } = store

  return (
    <div className={styles.container}>
      <SelectField
        labelText={'Member'}
        value={newOwner?.id}
        loading={organizationMembersLoading}
        setValue={setNewOwner}
        items={nonOwnerAndViewOnlyMembers.map((member) => ({
          id: member.id,
          label: member.full_name,
          labelContent: (
            <div className={styles.labelContent}>
              <Avatar
                size={16}
                online={!member.is_away}
                info={{
                  firstName: member.first_name,
                  lastName: member.last_name,
                  image: member.photo_url,
                }}
              />
              <Typography
                ariaLabel='name'
                variant='text-input-field-r'
                color='var(--content-primary-primary)'
              >
                {member.full_name}
              </Typography>
            </div>
          ),
        }))}
        selectProps={{
          placeholder: 'Select member',
        }}
        btnProps={{
          size: 'medium',
          style: {
            color: 'var(--content-neutral-primary)',
            height: '40px',
            paddingRight: '7px',
          },
        }}
      />
      <div className={styles.actions}>
        <Button text='Cancel' contained='secondary' size='medium' onClick={handleCancel} />
        <Button
          text='Make inbox owner'
          typeBtn='contained'
          size='medium'
          disabled={!newOwner}
          onClick={handleMakeOwner}
        />
      </div>
    </div>
  )
})
